import * as React from 'react';
import { useCallback } from 'react';

import { MenuList } from '@coursera/cds-core';
import { useTracker } from '@coursera/event-pulse/react';

import { AI_TOOL, type AI_TOOLS } from 'bundles/cml/shared/constants';

import _t from 'i18n!nls/cml';

type Props = {
  onChange: (change: { aiTool: AI_TOOLS; prompt?: string }) => void;
};

const GenerateTableMenuItem = ({ onChange }: Props) => {
  const track = useTracker();
  const handleClick = useCallback<() => $TSFixMe>(() => {
    onChange({ aiTool: AI_TOOL.TABLE });
    track('click_button', { button: { name: 'writing_assistant_generate_table' } });
  }, [track, onChange]);

  return <MenuList.Item onClick={handleClick}>{_t('Generate table')}</MenuList.Item>;
};

export default GenerateTableMenuItem;
